import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Shield } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#0A0F1A] text-white py-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Outfit' }}>
              dhanamm<span style={{ color: '#FF5722' }}>.com</span>
            </h3>
            <p className="text-[#94A3B8] text-sm leading-relaxed">
              Your trusted partner for seamless Demat account opening and trading guidance. Empowering investors across India.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4" style={{ fontFamily: 'Outfit' }}>Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-[#94A3B8] hover:text-[#FF5722] text-sm transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-[#94A3B8] hover:text-[#FF5722] text-sm transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-[#94A3B8] hover:text-[#FF5722] text-sm transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/broker-comparison" className="text-[#94A3B8] hover:text-[#FF5722] text-sm transition-colors">
                  Broker Comparison
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-[#94A3B8] hover:text-[#FF5722] text-sm transition-colors">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4" style={{ fontFamily: 'Outfit' }}>Resources</h4>
            <ul className="space-y-2">
              <li className="text-[#94A3B8] text-sm">Trading Guides</li>
              <li className="text-[#94A3B8] text-sm">Market Updates</li>
              <li className="text-[#94A3B8] text-sm">Investment Tips</li>
              <li className="text-[#94A3B8] text-sm">FAQs</li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4" style={{ fontFamily: 'Outfit' }}>Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-[#94A3B8] text-sm">
                <Mail size={16} className="text-[#FF5722]" />
                angeloneblr@gmail.com
              </li>
              <li className="flex items-center gap-2 text-[#94A3B8] text-sm">
                <Phone size={16} className="text-[#FF5722]" />
                +91 99023 00787
              </li>
              <li className="flex items-center gap-2 text-[#94A3B8] text-sm">
                <MapPin size={16} className="text-[#FF5722]" />
                AECS Layout, A Block, Singasandra, Bangalore 560068
              </li>
              <li className="flex items-center gap-2 text-[#94A3B8] text-sm">
                <Shield size={16} className="text-[#FF5722]" />
                Angel One SEBI Reg. No: 1N2000161534
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#475569] mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[#94A3B8] text-sm">
              © {new Date().getFullYear()} dhanamm.com. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <Link to="/privacy-policy" className="text-[#94A3B8] hover:text-[#FF5722] transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms-of-service" className="text-[#94A3B8] hover:text-[#FF5722] transition-colors">
                Terms of Service
              </Link>
              <Link to="/disclaimer" className="text-[#94A3B8] hover:text-[#FF5722] transition-colors">
                Disclaimer
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;